// A selectable card currently being used for Tier selection in this View.
const SelectableCard = ({
  icon,
  title,
  description,
  isSelected,
  onClick,
  disabled = false,
}) => {
  return (
    <div
      style={{
        transition: "all .05s ease-in-out",
        ...(disabled && { cursor: "not-allowed" }),
      }}
      className={`text-center ${
        !disabled ? "cursor-pointer" : ""
      } m-2 px-2 pt-2 pb-0 ${
        isSelected ? "bg-dropdown-selected" : "bg-transparent"
      } rounded ${
        !disabled
          ? "bg-dropdown-selected--hover border border-dropdown-selected-dark--hover"
          : "bg-light"
      }  ${isSelected ? "border-dropdown-selected-dark" : "border-superlight"}`}
      onClick={disabled ? null : onClick}
    >
      <div className="text-dark">{icon}</div>
      <h3 className="text-dark">{title}</h3>
      <div style={{ fontSize: 14 }} className="mb-1">
        {description}
      </div>
      <div style={{ fontSize: 24 }} className="pb-3">
        {isSelected ? (
          <i className="mdi mdi-check-circle text-primary" />
        ) : (
          <i className="mdi mdi-checkbox-blank-circle-outline text-lighter" />
        )}
      </div>
    </div>
  );
};

export default SelectableCard;
